import { useContext } from 'react'
import { store } from '../Context/Store'

export const useCurrentLocationIndex = () => {
  const { globalState } = useContext(store)
  return globalState?.siteData?.locationIndex ?? null
}

export default useCurrentLocationIndex
